import { appURLs } from "@/app/app-urls.mjs";
import type { GameDefinition } from "@/app/game-definition.mjs";
import GameIconBoxOW2 from "@/inline-assets/game-icon-box-overwatch2.svg";
import GameIconShapeOW2 from "@/inline-assets/game-icon-shape-overwatch2.svg";
import symbolName from "@/util/symbol-name.mjs";

export const GAME_SYMBOL_OVERWATCH2: unique symbol = symbolName("ow2");
const GameOW2 = {
  gameSymbol: GAME_SYMBOL_OVERWATCH2,
  friendlyName: ["common:games.ow2.short", "OW2"],
  fullName: ["common:games.ow2.long", "Overwatch 2"],
  shortName: "ow2" as const,
  gameColor: "#FF7526",

  iconShape: GameIconShapeOW2,
  iconBox: GameIconBoxOW2,
  icon: "",
  imageKeyart: `${appURLs.CDN}/blitz/ui/img/game-cover/overwatch2-min.webp`,

  isActive: false,
  preferFriendlyName: false as const,

  settings: () => Promise.resolve({ default: () => null }),
  navLinks: [],
  routes: [],
} satisfies GameDefinition<typeof GAME_SYMBOL_OVERWATCH2>;

declare module "@/__main__/app-state.mjs" {
  interface AppState {
    ow2: {
      wiki: {
        heroes: Record<number, unknown>;
        i18n: Record<string, string>;
      };
    };
  }
  // interface VolatileState {}
}

export default GameOW2;
